import React from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import emoji from 'emoji-mart/css/emoji-mart.css?inline';
import ExtStyleProvider from 'ext/components/StyleProvider';
import mobileVariables from './variables.css?inline';
import css from './app.css?inline';

const MobileGlobalStyle = createGlobalStyle`
  ${emoji.toString()}
  ${css.toString()}
  ${mobileVariables.toString()}
`;

export default function StyleProvider({ children }) {
  return (
    <ExtStyleProvider pattern="mobile">
      <MobileGlobalStyle />
      {children}
    </ExtStyleProvider>
  );
}

StyleProvider.propTypes = {
  children: PropTypes.node,
};
